import React from 'react';
import { Card, Statistic, Row, Col } from 'antd';
import { UserOutlined, FileTextOutlined, EnvironmentOutlined } from '@ant-design/icons';

interface CompanyDashboardProps {
  companyName: string;
  userCount: number;
  mapCount: number;
  reportCount: number;
}

const CompanyDashboard: React.FC<CompanyDashboardProps> = ({
  companyName,
  userCount,
  mapCount,
  reportCount,
}) => {
  return (
    <div>
      <h2>Dashboard de {companyName}</h2>
      <Row gutter={16}>
        <Col span={8}>
          <Card>
            <Statistic
              title="Usuarios"
              value={userCount}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Mapas"
              value={mapCount}
              prefix={<EnvironmentOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Reportes"
              value={reportCount}
              prefix={<FileTextOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CompanyDashboard;